// VNEC v29 — BOD V2 pnl wrapper (P&L Deep Dive)
// Loads /bod-v2-pnl.html in iframe full-height
export function renderBodV2Pnl() {
  return `<div style="width:100%;height:calc(100vh - 60px);margin:0;padding:0">
    <iframe src="/bod-v2-pnl.html" style="width:100%;height:100%;border:none;display:block"></iframe>
  </div>`;
}
window.__pageInit = null;
